// extracted by mini-css-extract-plugin
export var menuIcon = "_te-0";
export var menuIconInline = "_te-1";